module.exports.parseShortcodeArray = arrayString => {
  // replace \\ with '
  const parsed = JSON.parse(arrayString.slice(1, arrayString.length - 1)).map(
    elem => {
      if (typeof elem === 'string') {
        return elem.replace(/\\/g, "'");
      }

      if (typeof elem === 'object') {
        return Object.keys(elem).reduce((transformed, key) => {
          if (typeof elem[key] === 'string') {
            transformed[key] = elem[key].replace(/\\/g, "'");
          }

          return transformed;
        }, {});
      }

      return elem;
    }
  );

  return parsed;
};
